/**
 * Theme identifiers enum - NO STRING LITERALS!
 * SYNC: Keep in sync with REGISTERED_THEMES in registry.ts
 *
 * @example
 * ```typescript
 * import { ThemeId } from './identifiers';
 * const theme = getTheme(ThemeId.DEFAULT);
 * ```
 */
export enum ThemeId {
  DEFAULT = 'default',
  RUBY = 'ruby',
  OCEAN = 'ocean',
  FOREST = 'forest',
  SUNSHINE = 'sunshine',
  ROSE = 'rose',
  AQUA = 'aqua',
  TWILIGHT = 'twilight',
  AMBER = 'amber',
  SKY = 'sky',
  LIME = 'lime',
  LAVENDER = 'lavender',
  JADE = 'jade',
}

/**
 * Theme brightness variant.
 * Encoded in the stored preference string as `<theme>-<variant>`.
 * The backend `theme` field stores the full encoded string.
 */
export enum ThemeVariant {
  LIGHT = 'light',
  MEDIUM = 'medium',
  DARK = 'dark',
}
